import axios from 'axios'

import router from '@/router/index'
import apollo from '@/apolloClient'

import { GC_USER_ID, GC_AUTH_TOKEN } from '@/constants/jwt'

import { GC_USER_INFOS, GC_UPDATE_USER, GC_UPDATE_USER_PROFIL } from '@/graphql/auth'

const backendURL = process.env.VUE_APP_WEBHOOK_URL

export default {
    namespaced: true,
    state: {
        errorCode: null,
        errorMessage: null,
        user: null,
        userInfo: null,
        loggedIn: !!localStorage.getItem(GC_AUTH_TOKEN) //todo ??
    },
    getters: {
        getErrorMessage(state){
            return state.errorMessage
        },
        isLoggedIn(state){
            return state.loggedIn
        }
    },
    mutations: {
        setUser(state, data){
            if (data.user && data.token) {
                state.user = data.user
                
                localStorage.setItem(GC_AUTH_TOKEN, data.token)
                localStorage.setItem(GC_USER_ID, data.user.id)
                
                state.loggedIn = true //todo ??
            }
        },
        SET_USER_INFO(state, data){
            let userInfo = data.users[0]
            userInfo.lastPage = (data.lastPage && data.lastPage.length > 0 ? data.lastPage[0] : null)
            userInfo.courseEnd = (data.courseEnd && data.courseEnd.length > 0 ? true : false)

            state.userInfo = userInfo
            state.user = { id: userInfo.id }
        }
    },
    actions: {
        setUser({commit}, data){
            commit('setUser', data)
        },
        async login({dispatch, state}, data){
            state.errorMessage = ''
            
            let user = {
                email: data.email,
                password: data.password
            }

            const res = await axios.post(backendURL + '/signin', user)

            if (!res)
                return

            if (res.data.error)
                state.errorMessage = res.data.error

            window.lastLogTime = Date.now()

            return dispatch('setUser', res.data)
        },
        logout({state}){
            localStorage.removeItem(GC_AUTH_TOKEN)
            localStorage.removeItem(GC_USER_ID)

            state.user = null
            state.loggedIn = false

            router.push({ name: 'Auth' }).catch(err => err)
        },
        async subscription({ dispatch, state }, data){
            state.errorMessage = ''

            const email = (data.email ? data.email.trim() : null)

            if (!email)
                return false
            
            let user = {
                email,
                password: data.password,
                firstname: data.firstname,
                lastname: data.lastname,
            }

            try {
                const res = await axios.post(backendURL + '/signup', user)
                
                await dispatch('setUser', res.data)

                return res
            } catch (error) {
                if (error.response)
                    state.errorMessage = error.response.data.error
            }
            
            return false
        },
        async emailExist({ state }, email){
            state.errorCode = null
            state.errorMessage = ''

            try {
                const res = await axios.get(backendURL + '/checkEmail', {
                    params:{
                        email
                    }
                })
                
                return res.data.found
            } catch (error) {
                if (error.response) {
                    state.errorCode = error.response.status
                    state.errorMessage = error.response.data.error
                }
            }
            
            return true
        },
        async forgotPassword({ state }, email){
            state.errorMessage = ''

            try {
                const res = await axios.post(backendURL + '/sendResetEmail', {
                    email
                })
                
                return res.data
            } catch (error) {
                if (error.response)
                    state.errorMessage = error.response.data.error
            }
            
            return false
        },
        async resetPassword({ state }, { password, token }){
            state.errorMessage = ''

            try {
                const res = await axios.put(backendURL + '/resetPassword', {
                    newPassword: password,
                    uid: token,
                })
                
                return res.data
            } catch (error) {
                if (error.response)
                    state.errorMessage = error.response.data.error
            }
            
            return false
        },
        async getCurrentUserInfo ({ commit, dispatch, state }) {
            const currentUserId = localStorage.getItem(GC_USER_ID)

            if (currentUserId && state.loggedIn) {
              try {
                const response = await apollo.query({
                  query: GC_USER_INFOS,
                  variables: {
                    id: currentUserId
                  }
                })

                commit('SET_USER_INFO', response.data)
              }
              catch (err) {
                dispatch('logout')
              }
            } else {
                dispatch('logout')
            }
        },
        async updateUser({dispatch}, userInfo){
            let organizations = []

            if (userInfo.status < 2) {
                organizations = [{
                    user: userInfo.id,
                    organisation: userInfo.organization.id
                }]
            }

            await apollo.mutate({
                mutation: GC_UPDATE_USER,
                variables: {
                    id: userInfo.id,
                    experienced: userInfo.experienced,
                    fName: userInfo.fName,
                    lName: userInfo.lName,
                    status: userInfo.status,
                    organizations,
                    position: userInfo.position,
                    company: userInfo.company,
                    seniority: userInfo.seniority,
                    experienceSeminar: userInfo.experienceSeminar,
                    experienceCourse: userInfo.experienceCourse,
                    experienceOther: userInfo.experienceOther,
                    mailing: userInfo.mailing,
                }
            })

            return dispatch('getCurrentUserInfo')
        },
        async updateUserProfil({dispatch}, userInfo){
            try {
                await apollo.mutate({
                    mutation: GC_UPDATE_USER_PROFIL,
                    variables: {
                        id: userInfo.id,
                        experienced: userInfo.experienced,
                        fName: userInfo.fName,
                        lName: userInfo.lName,
                        mailing: userInfo.mailing,
                    }
                })

                await dispatch('getCurrentUserInfo')

                return true
            } catch {
                return false
            }
        },
        async updateUserPassword({ state, dispatch }, { newPassword }){
            const token = localStorage.getItem(GC_AUTH_TOKEN)

            if (!token) {
                return
            }

            state.errorMessage = ''

            try {
                const res = await axios.put(
                    backendURL + '/updatePassword',
                    {
                        newPassword
                    },
                    {
                        headers: {
                            authorization: `Bearer ${token}`
                        }
                    }
                )

                await dispatch('setUser', res.data)
                
                return res.data
            } catch (error) {
                if (error.response)
                    state.errorMessage = error.response.data.error
            }
            
            return false
        },
        async sendCongratsEmailIfNeeded({ state, dispatch }) {
            const token = localStorage.getItem(GC_AUTH_TOKEN)

            // Check if we can/need to send the congrats email
            if (!token || !state.userInfo || state.userInfo.courseEnd)
                return false

            state.errorMessage = ''

            // Check for multiple concurent call
            if (window.isSendingCongrats)
                return true

            window.isSendingCongrats = true

            try {
                const res = await axios.post(backendURL + '/sendCongratsEmail', null, {
                    headers: {
                        authorization: token ? `Bearer ${token}` : ''
                    }
                })

                // Log that the email was send
                await dispatch('Logs/save', {
                    id: null,
                    data_key: null,
                    data: {},
                    type_slug: 'course_end',
                }, { root: true })

                await dispatch('getCurrentUserInfo')

                window.isSendingCongrats = false

                return res.data
            } catch (error) {
                if (error.response)
                    state.errorMessage = error.response.data.error
            }

            window.isSendingCongrats = false
            
            return false
        },
    }
}